import { Field } from 'redux-form';
import { useValidation } from '@eti/providers';
import RadioSelection from './RadioSelection';
import SingleOperatorSelection from './SingleOperatorSelection';
import { jsx as _jsx } from "react/jsx-runtime";
const AirportTransferSelection = ({
  productName,
  handleRadioChange,
  operatorList,
  translation,
  handleOpenDrawer,
  labelNo,
  labelYes,
  selectOneLabel
}) => {
  const validate = useValidation(productName);
  const isOnlyOneOperator = operatorList.length === 1 && labelNo && labelYes;
  if (isOnlyOneOperator) {
    return /*#__PURE__*/_jsx(Field, {
      component: SingleOperatorSelection,
      handleChange: handleRadioChange,
      handleOpenDrawer: handleOpenDrawer,
      labelNo: labelNo,
      labelYes: labelYes,
      name: `${productName}.value`,
      operator: operatorList[0],
      productName: productName,
      selectOneLabel: selectOneLabel || '',
      translation: translation,
      validate: validate
    });
  }
  return /*#__PURE__*/_jsx(Field, {
    component: RadioSelection,
    handleChange: handleRadioChange,
    handleOpenDrawer: handleOpenDrawer,
    name: `${productName}.value`,
    options: operatorList,
    translation: translation,
    validate: validate
  });
};
export default AirportTransferSelection;
//# sourceMappingURL=AirportTransferSelection.js.map